import React from 'react';
import classNameBind from 'classnames/bind';
import Icon from '../Icon';
import Popover from '../Popover';
import SelectionListWrapper from '../SelectionList/components/SelectionListWrapper';
import SearchSelectionList from '../SearchSelectionList';
import styles from './DraggableDataBlock.module.css';
import Button from './components/Button';

const bindClasses = classNameBind.bind(styles);

const colors = {
  dimension: 'green',
  metric: 'blue',
  attribute: 'dark-violet',
  event: 'dark-pink',
  'consent-type': 'bluebonnet',
};

const DraggableDataBlock = ({
  text,
  type,
  width,
  marginHorizontal,
  marginVertical,
  inactive,
  setRef,
  selectionProps,
  extendedArea,
  dropped,
  menu,
  icon,
  dataId,
  onClick,
  id,
  droppedOptions,
  ...rest
} = {}) => {
  const renderDraggableContent = () => {
    if (selectionProps) {
      return menu
        ? (
          <SearchSelectionList
            activatorElement={
              (<Button color={colors[type]} text={text} onClick={() => { onClick(id); }} icon={icon} dataId={`${dataId}.activator`} />)
            }
            items={selectionProps.items}
            value={selectionProps.value}
            onItemSelected={selectionProps.onItemSelected}
            isLoading={selectionProps.isLoading}
            openProps={{ active: true }}
            dataId={`${dataId}.select`}
          />
        ) : (
          <Popover
            activatorElement={
              (<Button color={colors[type]} text={text} onClick={() => { onClick(id); }} icon={icon} dataId={`${dataId}.activator`} />)
            }
            position="bottom"
            childToggle={{ onItemSelected: () => true }}
            openProps={{ active: true }}
            dataId={`${dataId}.list`}
            noPadding
          >
            <SelectionListWrapper
              items={selectionProps.items}
              onItemSelected={selectionProps.onItemSelected}
              value={selectionProps.value}
              isLoading={selectionProps.isLoading}
              selectEvent="onMouseUp"
              dataId={`${dataId}.selectionOptions`}
              fixedHeight
              withPadding
            />
          </Popover>
        );
    }

    return (
      <React.Fragment>
        {
          icon
            ? (
              <span className={bindClasses('info-icon-left')}>
                <Icon
                  name={icon}
                  size="small"
                  dataId={`${dataId}.icon`}
                />
              </span>
            )
            : ''
        }
        {text}
      </React.Fragment>
    );
  };

  return (
    <div
      {...rest}
      ref={setRef}
      className={bindClasses('area', { extendedArea }, width)}
      data-ppuc-id={dataId}
      data-active={!inactive}
    >
      <div className={bindClasses(
        'fake-dropzone', `margin-v-${marginVertical}`, `margin-h-${marginHorizontal}`,
        { dropped, subdued: droppedOptions.subdued }, `dropped-type-${droppedOptions.type}`,
      )}
      >
        <div
          className={
            bindClasses('wrapper', `type-${type}`, { inactive })
          }
        >
          <Icon
            name="draggable"
            className={bindClasses('icon-dots', 'icon-left')}
            color={colors[type]}
            dataId={`${dataId}.dragIcon`}
          />
          <div className={bindClasses(selectionProps ? 'content-selection' : 'content-text')}>
            { renderDraggableContent() }
          </div>
          <Icon
            name="draggable"
            className={bindClasses('icon-dots', 'icon-right')}
            color={colors[type]}
            dataId={`${dataId}.dragIcon`}
          />
        </div>
      </div>
    </div>
  );
};

DraggableDataBlock.defaultProps = {
  width: 'full',
  droppedOptions: {
    type: 'default',
    subdued: true,
  },
  marginHorizontal: 'none',
  marginVertical: 'none',
  inactive: false,
  setRef: null,
  selectionProps: null,
  extendedArea: false,
  dropped: false,
  menu: false,
  icon: '',
  dataId: 'DraggableDataBlock',
  onClick: () => {},
  id: '',
};

export default DraggableDataBlock;
